var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgSimboloLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 1600,
    viewBox: "0 0 1600 1600",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M922.698 50.8316L1549.18 677.3C1616.94 745.077 1616.94 854.957 1549.18 922.7L922.702 1549.18C854.956 1616.94 745.076 1616.94 677.296 1549.18L50.8379 922.706C-16.945 854.959 -16.945 745.075 50.8324 677.297L677.296 50.8333C745.074 -16.9441 854.958 -16.9441 922.698 50.8316ZM612.062 1092.38L505.078 1199.36L766.109 1460.37L768.238 1462.38C786.319 1478.41 813.604 1478.44 831.718 1462.46L833.933 1460.38L906.978 1387.3L612.062 1092.38ZM815.648 888.782L700.854 1003.59L995.767 1298.5L1110.57 1183.71L815.648 888.782ZM301.465 995.769L995.756 301.477L1110.56 416.283L416.269 1110.56L301.465 995.769ZM1199.35 505.066L904.443 799.99L1199.36 1094.9L1460.38 833.938C1478.41 815.888 1479.08 787.048 1462.39 768.225L1460.39 766.099L1199.35 505.066ZM906.96 212.667L833.93 139.637C815.881 121.597 787.059 120.929 768.224 137.628L766.097 139.632L139.628 766.101C121.598 784.122 120.93 812.953 137.629 831.796L139.633 833.925L212.668 906.96L906.96 212.667Z",
    fill: "#292E38"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSimboloLogo);
export default __webpack_public_path__ + "static/media/bg-simbolo-logo.1c7bfdd68fe62070df2e1bb38b173d09.svg";
export { ForwardRef as ReactComponent };